import { render, staticRenderFns } from "./DeckDisplay.vue?vue&type=template&id=6fb2d9a0&"
import script from "./DeckDisplay.vue?vue&type=script&lang=js&"
export * from "./DeckDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports